import Model from '@ember-data/model';

import { attr, belongsTo } from '@ember-data/model';

export default class CatalogThemeModel extends Model {
  @attr('string') theme;
  @attr('string') definition;

  @attr('date') createDate;
}
